









import Vue from "vue";
export default Vue.extend({
  name: "LoadingScreen",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Lade...",
    },
    percent: {
      type: Number,
    },
  },
  data: function () {
    return {
      open: this.value,
    };
  },
  watch: {
    value() {
      this.open = this.value;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
});
